var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DateTime } from 'luxon';
import React from 'react';
import * as Avatar from '../Avatar';
import * as Content from '../Content';
import { Title } from './Title';
import { Body } from './Body';
import { View } from './View';
import { concatStyles, truncate } from 'utils';
import { useState } from 'react';
import { useCallback } from 'react';
var ARCHIVE_STYLES = 'absolute top-0 right-0 -mr-2 -mt-2 rounded-full text-white bg-metricBackground px-4 py-1 text-xs font-bold shadow z-20';
var DISABLED_STYLES = 'opacity-25 pointer-events-none';
export var Event = function (_a) {
    var event = _a.event, vertical = _a.vertical, onArchive = _a.onArchive, view = __rest(_a, ["event", "vertical", "onArchive"]);
    var initialDate = (event.dates && event.dates[0]) || {
        // this was Event as EventDateRange
        endDate: '',
        id: '',
        startDate: '',
    };
    var colorForTag = function () {
        switch (event.status) {
            case 'CANCELLED':
                return 'destructive';
            case 'DRAFT':
                return 'warning';
            default:
                return undefined;
        }
    };
    var _b = useState(null), storedTimeout = _b[0], setStoredTimeout = _b[1];
    var _c = useState(false), hovering = _c[0], setHovering = _c[1];
    var handleHover = useCallback(function (newHover) { return function () {
        if (storedTimeout) {
            clearTimeout(storedTimeout);
        }
        if (!newHover) {
            setStoredTimeout(setTimeout(function () {
                setHovering(newHover);
            }, 100));
        }
        else {
            setHovering(newHover);
        }
    }; }, [hovering, setHovering, setStoredTimeout, storedTimeout]);
    var _d = useState(false), archiving = _d[0], setArchiving = _d[1];
    var handleArchive = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    setArchiving(true);
                    return [4 /*yield*/, (onArchive === null || onArchive === void 0 ? void 0 : onArchive(event))];
                case 1:
                    _a.sent();
                    setArchiving(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(View, __assign({}, view, { onMouseOut: handleHover(false), onMouseOver: handleHover(true), className: concatStyles(archiving && DISABLED_STYLES) }),
        React.createElement(Avatar.Simple, { name: event.name, maxInitials: 1, color: event.color, imageUrl: event.iconUrl, className: "mr-2 my-auto" }),
        React.createElement("div", { className: "flex-col my-auto flex-grow" },
            React.createElement("div", { className: vertical ? 'flex flex-col' : 'flex flex-row' },
                (event === null || event === void 0 ? void 0 : event.status) !== 'PUBLISHED' ? (React.createElement("p", { className: vertical ? 'flex mr-auto mb-1' : 'flex' },
                    React.createElement(Content.Bubble, { bubbleStyle: colorForTag() }, event.status))) : null,
                React.createElement(Title, null, truncate(event.name, vertical ? 24 : 120))),
            React.createElement(Body, null, !DateTime.fromISO(initialDate.startDate).isValid ? ('Dates TBD') : (React.createElement(React.Fragment, null,
                DateTime.fromISO(initialDate.startDate).toFormat('MMMM, d, yyyy'),
                ' ',
                "\u2022",
                DateTime.fromISO(initialDate.startDate).toFormat('h:mma'),
                " -",
                ' ',
                DateTime.fromISO(initialDate.endDate).toFormat('h:mma')))),
            onArchive && hovering && !archiving ? (React.createElement("button", { className: ARCHIVE_STYLES, onMouseOver: handleHover(true), onClick: handleArchive }, "Archive")) : (React.createElement("span", { className: "hidden" })))));
};
Event.displayName = 'Card.Event';
